import { initParticle, updateRoll } from "./Utils";
import { Roll } from "./Options/Classes/Roll";
export class RollUpdater {
  getTransformValues(particle) {
    var _particle$roll;
    const roll = ((_particle$roll = particle.roll) === null || _particle$roll === void 0 ? void 0 : _particle$roll.enable) && particle.roll,
      rollHorizontal = roll && roll.horizontal,
      rollVertical = roll && roll.vertical;
    return {
      a: rollHorizontal ? Math.cos(roll.angle) : undefined,
      d: rollVertical ? Math.sin(roll.angle) : undefined
    };
  }
  init(particle) {
    initParticle(particle);
  }
  isEnabled(particle) {
    const roll = particle.options.roll;
    return !particle.destroyed && !particle.spawning && !!(roll !== null && roll !== void 0 && roll.enable);
  }
  loadOptions(options) {
    if (!options.roll) {
      options.roll = new Roll();
    }
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }
    for (const source of sources) {
      options.roll.load(source === null || source === void 0 ? void 0 : source.roll);
    }
  }
  update(particle, delta) {
    if (!this.isEnabled(particle)) {
      return;
    }
    updateRoll(particle, delta);
  }
}